import {Switch, Route, useRouteMatch} from "react-router-dom";

import '../../assets/styles/events/conferencesList.scss';
import '../../assets/styles/events/conferenceList/conferenceListPage.scss';

import AllEvents from "./All";
import FavoriteEvents from "./Favorite";
import PrivateRoute from "../../components/Route/PrivateRoute";

export default function EventsPage() {
    const { path } = useRouteMatch();

    return (
        <Switch>
            <Route
                exact
                path={path}
            >
                <AllEvents />
            </Route>
            <PrivateRoute
                exact
                path={`${path}/favorite`}
            >
                <FavoriteEvents />
            </PrivateRoute>
        </Switch>
    );
}
